import React from 'react';
import { render } from 'react-dom';
import { Router, browserHistory } from 'react-router';

// Import your routes so that you can pass them to the <Router /> component
import routes from './routes.js';
import '../static/lib/prism.js'
import '../static/lib/prism.css'
import initGa from './ga';

initGa(browserHistory);

render((
  <Router routes={routes} history={browserHistory} />
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./client/index.js